/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
/* eslint-disable no-extra-boolean-cast */
/* -------------------------------------------------------------------------- */
/*                              Config                                        */
/* -------------------------------------------------------------------------- */

const configQueryMap = {
  'navbar-vertical-collapsed': 'RAB_PATRIOT_phoenixIsNavbarVerticalCollapsed',
  'color-scheme': 'RAB_PATRIOT_phoenixTheme',
  'navigation-type': 'RAB_PATRIOT_phoenixNavbarPosition',
  'vertical-navbar-appearance': 'RAB_PATRIOT_phoenixNavbarVerticalStyle',
  'horizontal-navbar-shape': 'RAB_PATRIOT_phoenixNavbarTopShape',
  'horizontal-navbar-appearance': 'RAB_PATRIOT_phoenixNavbarTopStyle'
};

const initialConfig = {
  RAB_PATRIOT_phoenixIsNavbarVerticalCollapsed: false,
  RAB_PATRIOT_phoenixTheme: 'light',
  RAB_PATRIOT_phoenixNavbarTopStyle: 'default',
  RAB_PATRIOT_phoenixNavbarVerticalStyle: 'default',
  RAB_PATRIOT_phoenixNavbarPosition: 'horizontal',
  RAB_PATRIOT_phoenixNavbarTopShape: 'default',
  RAB_PATRIOT_phoenixIsRTL: false,
  RAB_PATRIOT_phoenixSupportChat: true
};

const CONFIG = { ...initialConfig };

const setConfig = (payload, persist = true) => {
  Object.keys(payload).forEach(key => {
    CONFIG[key] = payload[key];
    if (persist) {
      localStorage.setItem(key, payload[key]);
    }
  });
};

const resetConfig = () => {
  Object.keys(initialConfig).forEach(key => {
    CONFIG[key] = initialConfig[key];
    localStorage.setItem(key, initialConfig[key]);
  });
};

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

if (
  Object.keys(params).length > 0 &&
  Object.keys(params).includes('theme-control')
) {
  resetConfig();

  Object.keys(params).forEach(param => {
    if (configQueryMap[param]) {
      localStorage.setItem(configQueryMap[param], params[param]);
    }
  });
}

Object.keys(CONFIG).forEach(key => {
  if (localStorage.getItem(key) === null) {
    localStorage.setItem(key, CONFIG[key]);
  } else {
    try {
      setConfig({
        [key]: JSON.parse(localStorage.getItem(key))
      });
    } catch {
      setConfig({
        [key]: localStorage.getItem(key)
      });
    }
  }
});

if (!!JSON.parse(localStorage.getItem('RAB_PATRIOT_phoenixIsNavbarVerticalCollapsed'))) {
  document.documentElement.classList.add('navbar-vertical-collapsed');
}

if (localStorage.getItem('RAB_PATRIOT_phoenixTheme') === 'dark') {
  document.documentElement.setAttribute('data-bs-theme', 'dark');
} else if (localStorage.getItem('RAB_PATRIOT_phoenixTheme') === 'auto') {
  document.documentElement.setAttribute(
    'data-bs-theme',
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
}

if (localStorage.getItem('RAB_PATRIOT_phoenixNavbarPosition') === 'horizontal') {
  document.documentElement.setAttribute('data-navigation-type', 'horizontal');
}

if (localStorage.getItem('RAB_PATRIOT_phoenixNavbarPosition') === 'combo') {
  document.documentElement.setAttribute('data-navigation-type', 'combo');
}

export default {
  config: CONFIG,
  reset: resetConfig,
  set: setConfig
};
